export class HeatmapAlgorithmData {
    public IsDelayed: boolean;
    public TradableId: number;
    public RouteId: number;
    public Change: number;
    public PercentChange: number;
    public LastPrice: number;
}
